import { render, staticRenderFns } from "./systermAuthorFour.vue?vue&type=template&id=2c1d5c2c&scoped=true&"
import script from "./systermAuthorFour.vue?vue&type=script&lang=js&"
export * from "./systermAuthorFour.vue?vue&type=script&lang=js&"
import style0 from "./systermAuthorFour.vue?vue&type=style&index=0&id=2c1d5c2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1d5c2c",
  null
  
)

export default component.exports